import React from "react";
import {css} from "@emotion/react";

import {calculateRemSize as crs} from "@pg-design/helpers-css";
import {onDesktop} from "@pg-design/helpers-css/";
import {getThemeBreakpoint} from "@pg-design/styles-strings";
import {Text} from "@pg-design/text-module";

import {knowledgeSectionCategories} from "../../constants/knowledge_section_categories";
import {BlogCard} from "../cards/BlogCard";

interface IProps {
    handleCategoryClick: (e: React.MouseEvent<HTMLElement>, url: string) => void;
    className?: string;
}

export function ArticleListKnowledgeSection(props: IProps) {
    const {handleCategoryClick, className} = props;

    return (
        <section className={className}>
            <Text css={title} as="p" variant="headline_2">
                Szczypta konkretnej wiedzy
            </Text>
            <div css={categories}>
                {knowledgeSectionCategories.map((category) => (
                    <div css={categoryStyle} key={category.title} onClick={(e) => handleCategoryClick(e, category.url)}>
                        <div css={blogCardStyle}>
                            <BlogCard.Body css={blogCardBody}>
                                <BlogCard.Picture
                                    loading="lazy"
                                    sources={[
                                        {minWidthPX: 0, src: category.picture.md, width: 336, height: 160},
                                        {minWidthPX: 1024, src: category.picture.lg, width: 206, height: 160}
                                    ]}
                                    alt={category.title}
                                    imageStyle={{
                                        width: "100%"
                                    }}
                                />
                                <BlogCard href={category.url}>
                                    <BlogCard.SubHeader>{category.title}</BlogCard.SubHeader>
                                </BlogCard>
                                <BlogCard.CheckList items={category.bulletPoints} />
                                <BlogCard.NextIcon />
                            </BlogCard.Body>
                        </div>
                    </div>
                ))}
            </div>
        </section>
    );
}

const title = css`
    margin: 0 0 ${crs(4)} 0;

    ${onDesktop(css`
        margin: 0 0 ${crs(5)} 0;
    `)}
`;

const mdGap = crs(3);
const categories = css`
    display: flex;
    flex-direction: column;
    gap: ${crs(2)};
    align-items: center;

    ${onDesktop(css`
        flex-direction: row;
        gap: ${mdGap};
    `)}
`;

const categoriesAmount = knowledgeSectionCategories.length;
const gapsAmount = categoriesAmount - 1;

const categoryStyle = css`
    flex: 1 1 auto;
    max-width: 33.6rem;

    @media (min-width: ${getThemeBreakpoint().md}) {
        flex: 1 1 calc((100% - ${gapsAmount} * ${mdGap}) / ${categoriesAmount});
        max-width: none;
    }
`;

const blogCardBody = css`
    flex: 1 1 auto;
`;

const blogCardStyle = css`
    display: flex;
    min-height: 40.4rem;

    @media (min-width: ${getThemeBreakpoint().md}) {
        min-height: 46.8rem;
    }
`;
import React from "react";
import {css} from "@emotion/react";

import {calculateRemSize as crs} from "@pg-design/helpers-css";
import {onDesktop} from "@pg-design/helpers-css/";
import {getThemeBreakpoint} from "@pg-design/styles-strings";
import {Text} from "@pg-design/text-module";

import {knowledgeSectionCategories} from "../../constants/knowledge_section_categories";
import {BlogCard} from "../cards/BlogCard";

interface IProps {
    handleCategoryClick: (e: React.MouseEvent<HTMLElement>, url: string) => void;
    className?: string;
}

export function ArticleListKnowledgeSection(props: IProps) {
    const {handleCategoryClick, className} = props;

    return (
        <section className={className}>
            <Text css={title} as="p" variant="headline_2">
                Szczypta konkretnej wiedzy
            </Text>
            <div css={categories}>
                {knowledgeSectionCategories.map((category) => (
                    <div css={categoryStyle} key={category.title} onClick={(e) => handleCategoryClick(e, category.url)}>
                        <div css={blogCardStyle}>
                            <BlogCard.Body css={blogCardBody}>
                                <BlogCard.Picture
                                    loading="lazy"
                                    sources={[
                                        {minWidthPX: 0, src: category.picture.md, width: 336, height: 160},
                                        {minWidthPX: 1024, src: category.picture.lg, width: 206, height: 160}
                                    ]}
                                    alt={category.title}
                                    imageStyle={{
                                        width: "100%"
                                    }}
                                />
                                <BlogCard href={category.url}>
                                    <BlogCard.SubHeader>{category.title}</BlogCard.SubHeader>
                                </BlogCard>
                                <BlogCard.CheckList items={category.bulletPoints} />
                                <BlogCard.NextIcon />
                            </BlogCard.Body>
                        </div>
                    </div>
                ))}
            </div>
        </section>
    );
}

const title = css`
    margin: 0 0 ${crs(4)} 0;

    ${onDesktop(css`
        margin: 0 0 ${crs(5)} 0;
    `)}
`;

const mdGap = crs(3);
const categories = css`
    display: flex;
    flex-direction: column;
    gap: ${crs(2)};
    align-items: center;

    ${onDesktop(css`
        flex-direction: row;
        gap: ${mdGap};
    `)}
`;

const categoriesAmount = knowledgeSectionCategories.length;
const gapsAmount = categoriesAmount - 1;

const categoryStyle = css`
    flex: 1 1 auto;
    max-width: 33.6rem;

    @media (min-width: ${getThemeBreakpoint().md}) {
        flex: 1 1 calc((100% - ${gapsAmount} * ${mdGap}) / ${categoriesAmount});
        max-width: none;
    }
`;

const blogCardBody = css`
    flex: 1 1 auto;
`;

const blogCardStyle = css`
    display: flex;
    min-height: 40.4rem;

    @media (min-width: ${getThemeBreakpoint().md}) {
        min-height: 46.8rem;
    }
`;
